import { render, staticRenderFns } from "./SafetyPage.vue?vue&type=template&id=1a196c1e&"
import script from "./SafetyPage.vue?vue&type=script&lang=js&"
export * from "./SafetyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports